import numeral from 'numeral';

export const formatPrice = (price) => { //eslint-disable-line
  const priceFormat = Number.isInteger(price) ? '$0,0' : '$0,0.00';
  return numeral(price, 0).format(priceFormat);
};
